import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { ArDataResponse } from '../common.interface';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ArDataResolverService implements Resolve<ArDataResponse> {
  constructor(
    private http: HttpClient,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.http.get<ArDataResponse>('assets/ar-data.json');
  }
}
